<template>
  <div class="wrapper">
    <p class="title text-center">Edit Full Name</p>
    <div class="content">
      <div class="full-name">
        <div class="new-name text-center">Please edit your name below.</div>
        <div class="input-wrapper">
          
          <div class="from-inputs">
            <div class="first" style="margin-bottom:16px">
              <div class="form-group m-d-gruop " :class="!$v.form.user.first_name.maxLength && 'invalid-value'">
                <b-form-input v-model="form.user.first_name" type="text" required maxLength="20" :class="{'cursor-not-allowed':form.user.first_name && form.user.first_name.length >=20}"/>
                <label>First Name</label>
              </div>
              <div class="err-wrapper">
                <div class="first-name-err" v-if="!$v.form.user.first_name.maxLength" >
                  <span class="error-value">First Name can't exceed 20 characters.</span>
                </div>
              </div>
            </div>
            <div class="last">
              <div class="form-group m-d-gruop" :class="!$v.form.user.last_name.maxLength && 'invalid-value'">
                <b-form-input v-model="form.user.last_name" type="text" required maxLength="20" :class="{'cursor-not-allowed': form.user.last_name && form.user.last_name.length >= 20}"/>
                <label>Last Name</label>
              </div>
              <div class="err-wrapper">
                <div class="first-name-err" v-if="!$v.form.user.last_name.maxLength">
                  <span class="error-value">Last Name can't exceed 20 characters.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- err  -->
      
      </div>
        <!-- update company checkbox  -->
      <div  v-if="getUserData.is_system_user" class="entity-checkbox" :class="{'entity-checkbox-checked' : form.update_cloud}">
        <b-form-checkbox id="UpdateCloudFromFullNameCheckbox" v-model="form.update_cloud" name="update_cloud">
          Update my name on all my companies
        </b-form-checkbox>
      </div>

    </div>
    <!-- action btns  -->
    <hr class="h-line" />
    <div class="action-btns" style="width: 416px; margin:auto">
      <button class="submit-btn btn btn-primary" size="md"
        @click="onSubmit" :disabled="isDirty || getLoading || !form.user.first_name || !form.user.last_name || !$v.form.user.first_name.maxLength || !$v.form.user.last_name.maxLength">
        <i v-if="getLoading" class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"></i>
        <span v-else>Save</span>
      </button>
      <button class="btn btn-outline-danger ml-32" @click="$bvModal.hide('userFullName')">
        Cancel
      </button>
    </div>

  </div>
</template>

<script>
import { required,maxLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["loggedInUser"],
  data() {
    return {
      submitted: false,
      isDirty : true,
      form: {
        user: {
          first_name: null,
          last_name: null,
        },
        update_cloud: false,
      },
    };
  },
  validations: {
    form: {
      user: {
        first_name: { required, maxLength: maxLength(20) },
        last_name: { required , maxLength: maxLength(20) },
      },
    },
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("userFullName");
    },
    form: {
      handler: 'checkDirty',
      deep: true,
      immediate: true
    },
  },
  computed: {
    ...mapGetters("user", [
      "getLoading",
      "getUserFirstName",
      "getUserLastName",
      "getModalState",
      "getUserData"
    ]),
  },
  methods: {
    ...mapActions("user", ["updateUserNameAction", "resetState"]),
    onSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if(!this.$v.$error){
        this.updateUserNameAction({
          form: this.form,
        });
      } 
    },
    checkDirty() {
      const { form, getUserFirstName, getUserLastName } = this;
      let isDirty = true;
      if ( form.user.first_name != getUserFirstName || form.user.last_name != getUserLastName ) {
        isDirty = false;
      }else if(form.update_cloud){
        isDirty = false;
      }
      this.isDirty = isDirty;
    },
  },
  beforeMount() {
    this.resetState();
    const { getUserFirstName, getUserLastName } = this;
    this.form.user.first_name = getUserFirstName ? getUserFirstName : null;
    this.form.user.last_name = getUserLastName ? getUserLastName : null;
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .cursor-not-allowed{
    cursor: not-allowed;
  }
}
</style>
<style lang="scss">
// .modal-dialog.modal-lg.modal-dialog-scrollable {
//  width: 5px!important;
// }
div#userFullName___BV_modal_content_ {
  // width: 800px!important;
  // border-radius: 26px;
  
  
  button.submit-btn.btn.btn-primary{
    color: #ffffff!important;
    font-size: 16px;
   
   margin-right: 0px!important;
    font-weight: 400;
    &:disabled{
      background-color: #9FB2BF;
      border-color: #9FB2BF;
    }
  }
  .modal-content .modal-body .wrapper .title {
    font-size: 17px;
    font-weight: 700;
    font-family: "lato";
    margin-bottom: 40px;
    color: #000000;
  }
  .content {
    width: 416px;
    margin: auto;
    .entity-checkbox {
      margin-top: 24px!important;
      color: #787878;
      label.custom-control-label{
        font-size: 16px;
        font-family: "lato";
        line-height: 19.2px!important;
        font-weight: 600;
        
      }
      .custom-checkbox .custom-control-label::before {
        border: 3px solid #103f5e !important;
        border-radius: 4px!important;
        width: 17px!important;
        height: 17px!important;
      }
      .custom-control-input:checked ~ .custom-control-label::after{
        border: none!important;
        width: 17px!important;
        height: 17px!important;
      }




    }
    .err-wrapper div{
      margin: 8px 0px 0px 0px!important;
    }
    .err-wrapper{
      margin-top: 8px !important;
      padding-left: 0px!important;
      margin-left: 20px!important;
      .error-value{
        font-weight: 600!important;
      }
    }
    .from-inputs {
      width: 416px;
    }
    .m-d-gruop > label{
      color: #787878!important;
      opacity: 1!important;
    }
    .form-control:valid ~ label{
      font-weight: 700!important;
      opacity: 1!important;
      color: #103f5e!important;
    }
    .form-control:focus ~ label{
      font-weight: 700!important;
      opacity: 1!important;
      color: #103f5e!important;
    }
    .m-d-gruop > input{
      opacity: 1!important;
      color: rgba(0, 0, 0, 0.87)!important;
    }
    .current-name{
      margin-bottom: 0px!important;
    }
    .input-wrapper{
      
      
      
      .label {
        font-size: 16px;
        font-family: "lato";
      margin-right: 0px!important;
        font-weight: 400;
        color: #787878;
        margin-right: 8px!important;
      opacity: 1!important;
      margin-left: 20px;
    }
    .text-value{
      font-size: 16px;
      font-family: "lato";
      line-height: 17px;
      margin-right: 0px!important;
      font-weight: 700;
      color: #4A4A4A;
      margin-bottom: 0px!important;
    }
    }
    .sep-change-name{
      height: 1px;
      width: 416px;
      background: #707070;
      opacity: .15;
      margin-bottom: 32px;
      margin-top: 32px;
    }
    .new-name{
      font-size: 16px;
      font-family: "lato";
      font-weight: 400;
      color: #4A4A4A;
      margin-bottom: 24px;
    }
  }

  .h-line{
    margin-top: 40px;
  }

  .action-btns {
    .submit-btn {
        margin-right: 32px;
    }
}
}
</style>
